import ChatsList from './ChatsListContainer';

export default ChatsList;
